/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Component } from '@angular/core';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import moment from 'moment-timezone';
import { Agency, Profile, User } from 'rest-client';
import { Observable } from 'rxjs';

//import { ActiveCampaignService } from '@core/services/active-campaign/active-campaign.service';
import { GoogleTagManagerService } from '@core/services/analytics/google-tag-manager.service';
import { AppConfigService } from '@core/services/app-config/app-config.service';

import { ActiveCampaignService } from './modules/core/services/active-campaign/active-campaign.service';
import { UserService } from './modules/core/services/user/user.service';
import { AuthStateModel } from './modules/core/states/auth-state/auth.model';
import { AuthState } from './modules/core/states/auth-state/auth.state';
import { SetTestParamsAction } from './modules/core/states/calculated-price-state/calculated-price.actions';
import { TIMEZONE } from './modules/shared/const/date-picker.consts';

const EXPERIMENT_VERSION = 'initial';
const DESKTOP_SCREEN = 1;
const MOBILE_SCREEN = 2;
const TAB_SCREEN = 3;

@UntilDestroy()
@Component({
  selector: 'bkg-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  @Select(AuthState.authData) authData$: Observable<AuthStateModel>;
  userData: User;
  agencyData: Agency;

  typeVisitor: string;
  userId: number = null;
  agenciaID: number = null;
  typeUser: string;
  formVersion: string;

  constructor(
    private gtmService: GoogleTagManagerService,
    private activeCampaignService: ActiveCampaignService,
    private store: Store,
    private appConfigService: AppConfigService,
    private userService: UserService
  ) {
    this.gtmService.addGtmToDom();
    this.store.dispatch(
      new SetTestParamsAction(null, EXPERIMENT_VERSION, this.getResolution())
    );
    this.activeCampaignService.addActiveCampaignToDoM();
    moment.tz.setDefault(TIMEZONE);
    this.pushGoogleData();
    this.sendUtmData();
  }

  getResolution(): number {
    if (window.screen.width >= 1000) {
      return DESKTOP_SCREEN;
    } else if (window.screen.width >= 700) {
      return TAB_SCREEN;
    } else {
      return MOBILE_SCREEN;
    }
  }

  setGTMCustomVars(): void {
    this.gtmService.setCustomVars(
      this.formVersion,
      this.typeVisitor,
      this.userId,
      this.typeUser
    );
  }

  setUserData(): void {
    if (this.agencyData?.id) {
      this.typeVisitor = 'agencia';
      this.agenciaID = this.agencyData.id;
      this.typeUser = 'logeado';
    } else if (this.userData?.id) {
      this.typeVisitor = this.getUserType(this.userData.profiles);
      this.userId = this.userData.id;
      this.typeUser = 'logeado';
    } else {
      this.typeVisitor = 'esporádico';
      this.typeUser = 'esporádico';
    }
  }

  sendUserTypeDatalayerPush(): void {
    this.gtmService.pushOnDataLayer({
      ago_platform: 'form',
      userId: this.userId,
      agenciaID: this.agenciaID,
      'tipo-de-cliente': this.typeVisitor,
      'tipo-de-user': this.typeUser,
    });
    this.gtmService.pushBookingActionOnDataLayer({
      ago_platform: 'form',
      userId: this.userId,
      agenciaID: this.agenciaID,
      'tipo-de-cliente': this.typeVisitor,
      'tipo-de-user': this.typeUser,
    });
  }

  private getUserType(profiles: Profile[]): string {
    if (!this.userData?.defaultInvoiceProfileId) return 'particular';
    const isCompany = profiles.some((profile: Profile) => {
      return (
        profile.hasOwnProperty('companyId') &&
        +profile.id === +this.userData.defaultInvoiceProfileId
      );
    });

    if (isCompany) return 'empresa';
    return 'profesional';
  }

  private pushGoogleData(): void {
    this.authData$
      .pipe(untilDestroyed(this))
      .subscribe((authData: AuthStateModel) => {
        this.formVersion = this.appConfigService.getFormVersionStorage();
        this.userData = authData.user;
        this.agencyData = authData.agency;
        this.setUserData();
        this.setGTMCustomVars();
        this.sendUserTypeDatalayerPush();
      });
  }

  private sendUtmData(): void {
    this.authData$
      .pipe(untilDestroyed(this))
      .subscribe((authData: AuthStateModel) => {
        if (authData?.user?.email) {
          this.userService.sendUtm(authData.user, authData.user.email);
        }
      });
  }
}
